<script lang="ts">

    export let size = 30;
    export let color = '#fff';

</script>
<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 30.849 30.849">
    <path fill={color} d="M33.419,15.424h-3.04A12.562,12.562,0,0,0,19.923,4.968V1.928H16.067v3.04A12.562,12.562,0,0,0,5.611,15.424H2.571V19.28h3.04A12.562,12.562,0,0,0,16.067,29.736v3.04h3.856v-3.04A12.562,12.562,0,0,0,30.379,19.28h3.04V15.424Zm-6.964,0H23.449A5.8,5.8,0,0,0,19.923,11.9V8.892a8.7,8.7,0,0,1,6.532,6.532Zm-8.46,3.856a1.928,1.928,0,1,1,1.928-1.928A1.928,1.928,0,0,1,17.995,19.28ZM16.067,8.892V11.9a5.8,5.8,0,0,0-3.526,3.526H9.535A8.7,8.7,0,0,1,16.067,8.892ZM9.535,19.28H12.54a5.8,5.8,0,0,0,3.526,3.526v3.005A8.7,8.7,0,0,1,9.535,19.28Zm10.388,6.532V22.807a5.8,5.8,0,0,0,3.526-3.526h3.005A8.7,8.7,0,0,1,19.923,25.812Z" transform="translate(33.419 32.777) rotate(180)"/>
</svg>
  